export const getParticipants = (transcription, organizerName) => {
  if (!transcription || !organizerName) return null

  let parsedTranscription = transcription
  if (typeof transcription === 'string') {
    try {
      parsedTranscription = JSON.parse(transcription)
    } catch (err) {
      return null
    }
  }
  if (!Array.isArray(parsedTranscription)) return null

  const filteredParticipants = parsedTranscription.filter(
    (item) => item?.name && item.name.toLowerCase() !== organizerName.toLowerCase()
  )

  const uniqueParticipants = [...new Set(filteredParticipants.map((item) => item.name))]

  return uniqueParticipants
}

export const formatParticipants = (participants) => {
  const participantsString = participants.join(', ')

  return participantsString
}
